import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = "G-35GN66TCT9";

/**
 * Fires a GA4 `page_view` event on every client-side route change.
 *
 * The initial page view is already sent by the gtag snippet in
 * `public/index.html`, so we skip the first render to avoid double-counting.
 * A `requestAnimationFrame` defers the call one tick so react-helmet-async
 * has time to update `document.title` before we read it.
 */
export default function RouteChangeTracker() {
    const location = useLocation();
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (typeof window.gtag !== "function") return;

        const rafId = window.requestAnimationFrame(() => {
            window.gtag("event", "page_view", {
                page_path: location.pathname + location.search + location.hash,
                page_location: window.location.href,
                page_title: document.title,
                send_to: GA_MEASUREMENT_ID,
            });
        });

        return () => window.cancelAnimationFrame(rafId);
    }, [location]);

    return null;
}
